import * as React from 'react';
import { Route } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import Layout from './sidebar/Layout';

import ProjectManagerHomePage from 'pages/ProjectManager/Homepage';
import PMInProgressProjects from 'pages/ProjectManager/InProgressProjects';
import PMDelayedProjects from 'pages/ProjectManager/DelayedProjects';
import PMValidatedProjects from 'pages/ProjectManager/ValidatedProjects';
import PMProjectDisplay from 'pages/ProjectManager/ProjectDisplay';
import PMTextDisplay from 'pages/ProjectManager/PMtextdisplay';
import AssignedTraductionText from 'pages/AdminClient/assignedtraductiontext';
import PMUsersManagement from 'pages/ProjectManager/UsersManagement';
import PMCreateProject from 'pages/ProjectManager/PMCreateProject';
import Profile from 'pages/shared/Profile';

export default class ProjectManagerMainMenu extends React.Component {
  render() {
    return (
      <Layout>
        <Route
          path="/ProjectManager/MainMenu"
          render={(props) => <ProjectManagerHomePage {...props} reload={true} />}
        />

        <Route
          path="/ProjectManager/ProjectsEnCours"
          component={PMInProgressProjects}
        />

        <Route
          path="/ProjectManager/ProjectsEnRetard"
          component={PMDelayedProjects}
        />

        <Route
          path="/ProjectManager/ProjectsValides"
          component={PMValidatedProjects}
        />

        <Route
          path="/ProjectManager/DetailsProject"
          component={PMProjectDisplay}
        />

        <Route
          path="/ProjectManager/TextDetails"
          component={PMTextDisplay}
        />

        <Route
          path="/ProjectManager/assignedtraductiontext"
          component={AssignedTraductionText}
        />

        <Route
          path="/ProjectManager/MonProfil"
          component={Profile}
        />
        <Route
          exact
          path="/ProjectManager/UserManagement"
          component={PMUsersManagement}
        />
        <Route
          exact
          path="/ProjectManager/CreateProject"
          component={PMCreateProject}
        />


        <Route path="*">
          <Redirect to="/ProjectManager/MainMenu" />
        </Route>
      </Layout>
    );
  }
}


